import React, { Component } from 'react'
import { Button, Col, Modal, Popconfirm, Row } from 'antd'
import OrderLineForm from './OrderLineForm'

class OrderLineModal extends Component {
  render() {
    const {
      visibleOrderLine,
      onCancelOrderLine,
      submittingLine,
      removingLine,
      orderLineModalType,
      orderLineFormRef,
      isUpdatable,
      addLine,
      updateLine,
      removeLine,
    } = this.props
    return (
      <Modal
        visible={visibleOrderLine}
        title={orderLineModalType !== 'edit' ? 'Add Order Line' : 'Update Order Line'}
        onCancel={onCancelOrderLine}
        destroyOnClose={true}
        width={1234}
        footer={
          isUpdatable === true ? (
            <Row>
              <Col span={24} style={{ textAlign: 'right' }}>
                {orderLineModalType === 'edit' && (
                  <Popconfirm
                    title="Are you sure remove this order line?"
                    onConfirm={removeLine}
                    okText="Yes"
                    cancelText="No">
                    <Button type="danger" loading={removingLine} style={{ marginLeft: 8 }}>
                      Remove
                    </Button>
                  </Popconfirm>
                )}
                <Button
                  loading={submittingLine}
                  type="primary"
                  onClick={orderLineModalType === 'new' ? addLine : updateLine}>
                  {orderLineModalType === 'new' ? 'Create' : 'Update'}
                </Button>
              </Col>
            </Row>
          ) : null
        }>
        <Row>
          <OrderLineForm {...this.props} ref={orderLineFormRef} />
        </Row>
      </Modal>
    )
  }
}

OrderLineModal.propTypes = {}
OrderLineModal.defaultProps = { orderLineModalType: 'new' }

export default OrderLineModal
